import { useQuery } from "react-query";
import { t } from "@/i18n-js/instance";
import type { CoursesDirectory } from "@/react/types/CoursesDirectory";
import { coursesDirectoryApi } from "@circle-react/api/coursesDirectoryApi";
import { useToast } from "@circle-react-uikit/ToastV2";

export const useShowCoursesDirectory = () => {
  const toastr = useToast();

  return useQuery<CoursesDirectory>({
    queryKey: ["courses/directory", "show"],
    queryFn: () => coursesDirectoryApi.show(),
    onError: () => toastr.error(t("error")),
  });
};
